/**
 * Supabase Configuration - Single Source of Truth
 *
 * These are PUBLIC credentials (anon key) - safe to embed in frontend.
 * The service role key is ONLY used in Edge Functions (never here).
 *
 * Environment variables (VITE_*) are injected at build time by Vite.
 * Configured in Cloudflare Pages dashboard for production/preview.
 *
 * @module integrations/supabase/config
 */

const ENV = typeof import.meta !== "undefined" ? import.meta.env : undefined;
const ENV_URL = ENV?.VITE_SUPABASE_URL;
const ENV_ANON_KEY = ENV?.VITE_SUPABASE_ANON_KEY || ENV?.VITE_SUPABASE_PUBLISHABLE_KEY;
const ENV_PROJECT_ID = ENV?.VITE_SUPABASE_PROJECT_ID;

// Local development: only when actually on localhost AND no cloud URL configured
const isLocalHost = typeof window !== "undefined"
  && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

// Only use local Supabase when truly on localhost with no cloud URL override
const useLocal = isLocalHost && !ENV_URL;

const LOCAL_URL = ENV?.VITE_SUPABASE_LOCAL_URL || "http://localhost:54321";
const LOCAL_ANON_KEY = ENV?.VITE_SUPABASE_LOCAL_ANON_KEY || ENV_ANON_KEY;

// Fail fast if env vars missing in production
if (!useLocal && (!ENV_URL || !ENV_ANON_KEY)) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY environment variables.')
}

export const SUPABASE_CONFIG = {
  url: useLocal ? LOCAL_URL : ENV_URL!,
  anonKey: useLocal ? (LOCAL_ANON_KEY || '') : ENV_ANON_KEY!,
  projectId: ENV_PROJECT_ID || "kwfkbraccnnociihosif",
} as const;

// Derived exports for convenience
export const SUPABASE_URL = SUPABASE_CONFIG.url;
export const SUPABASE_ANON_KEY = SUPABASE_CONFIG.anonKey;
export const SUPABASE_PROJECT_ID = SUPABASE_CONFIG.projectId;
export const FUNCTIONS_URL = `${SUPABASE_CONFIG.url}/functions/v1`;
